var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { omit } from 'lodash';
var PIPForm = /** @class */ (function () {
    function PIPForm(formId, pip, jwt) {
        this.formId = formId;
        this.pip = pip;
        this.jwt = jwt;
    }
    PIPForm.prototype.form = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formType, children, _a, schema, translations, data;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.pip.getObjectType(this.formId, this.jwt)];
                    case 1:
                        formType = _b.sent();
                        return [4 /*yield*/, Promise.all(formType.children.map(function (key) { return _this.pip.getObjectType(key, _this.jwt); }))];
                    case 2:
                        children = _b.sent();
                        return [4 /*yield*/, Promise.all([
                                this.getFormSchema(formType),
                                this.getFormTranslations(children),
                                this.getFormData(children),
                            ])];
                    case 3:
                        _a = _b.sent(), schema = _a[0], translations = _a[1], data = _a[2];
                        return [2 /*return*/, __assign(__assign(__assign({}, schema), data), { translations: translations })];
                }
            });
        });
    };
    PIPForm.prototype.submit = function (formData, extraData) {
        if (extraData === void 0) { extraData = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var formType, dataTypeKey, dataType, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pip.getObjectType(this.formId, this.jwt)];
                    case 1:
                        formType = _a.sent();
                        dataTypeKey = formType.children.find(function (child) { return child.indexOf('data') !== -1; });
                        if (!dataTypeKey) {
                            throw "Unable to submit form data, unable to locate the data object for formId: " + this.formId;
                        }
                        return [4 /*yield*/, this.pip.getObjectType(dataTypeKey, this.jwt)];
                    case 2:
                        dataType = _a.sent();
                        data = __assign(__assign({}, extraData), { data: formData });
                        return [2 /*return*/, this.pip.updateObject(dataType, data, this.jwt)];
                }
            });
        });
    };
    PIPForm.prototype.getFormSchema = function (formType) {
        return __awaiter(this, void 0, void 0, function () {
            var form;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.pip.getLatestObjectForType(formType, this.jwt, true)];
                    case 1:
                        form = _a.sent();
                        return [2 /*return*/, {
                                title: form.json['page-title'],
                                schema: form.json.schema,
                                // Some solutions use "uiSchema" as a property in their form data instead of "ui"
                                uiSchema: form.json.ui || form.json.uiSchema || {},
                            }];
                }
            });
        });
    };
    PIPForm.prototype.getFormTranslations = function (childTypes) {
        return __awaiter(this, void 0, void 0, function () {
            var type, translations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = childTypes.find(function (type) { return type.slug.indexOf('i18n') !== -1; });
                        if (!type) {
                            return [2 /*return*/, {}];
                        }
                        return [4 /*yield*/, this.pip.getLatestObjectForType(type, this.jwt, true)];
                    case 1:
                        translations = _a.sent();
                        return [2 /*return*/, (translations.json || {})];
                }
            });
        });
    };
    PIPForm.prototype.getFormData = function (childTypes) {
        return __awaiter(this, void 0, void 0, function () {
            var type, formData, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        type = childTypes.find(function (type) { return type.slug.indexOf('data') !== -1; });
                        if (!type) {
                            return [2 /*return*/, {
                                    data: {},
                                    extraData: {},
                                }];
                        }
                        return [4 /*yield*/, this.pip.getLatestObjectForType(type, this.jwt)];
                    case 1:
                        formData = _a.sent();
                        result = (formData.json || {});
                        return [2 /*return*/, {
                                // Support the old format for form data where the data is stored directly as formData
                                // As well as the new format where it is nested in the formData.data property
                                data: 'data' in result ? result.data : result,
                                extraData: omit(result, 'data'),
                            }];
                }
            });
        });
    };
    return PIPForm;
}());
export default PIPForm;
//# sourceMappingURL=form.js.map